import {
  faArrowLeft,
  faCheckCircle,
  faCircleMinus,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  AiAsistant,
  DocPreviewer,
  DocumentNotes,
} from "@onefront/documents-smart-components";
import { useTranslation } from "@onefront/react-sdk";
import VaporPage from "@vapor/react-custom/VaporPage";
import VaporToolbar from "@vapor/react-custom/VaporToolbar";
import { Alert, AlertTitle, Box, Grid } from "@vapor/react-material";
import IconButton from "@vapor/react-material/IconButton";
import { Stack } from "@vapor/react-material/Stack";
import { useEffect, useState } from "react";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import { Loading } from "../documents/document-components/Loading";
import { useClientInformationStore } from "../store/useClientInformationStore";
import { DeleteDocumentAlert } from "./document-details-components/DeleteDocumentAlert";
import DocumentDetailUpperBar from "./document-details-components/DocumentDetailUpperBar";
import { DocumentDetailsFooter } from "./document-details-components/DocumentDetailsFooter";
import DocumentDetails from "./document-details-components/DocumentDetailsProps";
import { useGetDocumentById } from "./hooks/useGetDocumentById";
import { checkIdExists } from "../../utils/checkIdExists";
import { config } from "../../config";
import { IframeWrapper } from "../../common/IframeWraped";

export const DocumentPageDetail = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [expandedDetails, setExpandedDetails] = useState(true);
  const [expandedComment, setExpandedComment] = useState(false);
  const [expandedAssistant, setExpandedAssistant] = useState(false);
  const [statusOnDelete, setStatusOnDelete] = useState(false);
  const [previewType, setPreviewType] = useState("");
  const { id, workspaceId } = useParams();
  const [reload, setReload] = useState(false);
  const [openModalDelete, setOpenModalDelete] = useState(false);
  const [newName, setNewName] = useState("");
  const [response, setResponse] = useState();
  const [showError, setShowError] = useState(false);
  const [checkVisibility, setCheckVisibility] = useState(false);

  const { data, loading, error, fetch } = useGetDocumentById({
    id,
    workspaceId,
    reload,
    setReload,
    previewType,
    checkVisibility,
    setCheckVisibility,
  });

  if (statusOnDelete) {
    setStatusOnDelete(false);
    setTimeout(() => navigate("/"), 2000);
  }

  useEffect(() => {
    if (location.state?.expandComment) {
      setExpandedComment(true);
    }
  }, [location.state]);

  useEffect(() => {
    if (window.aptrinsic) {
      window.aptrinsic("track", "docs:ACCESS-COMMENTS");
    }
  }, [expandedComment]);
  const {
    selectedTenant: currentCompany,
    selectedWorkspace: ws,
    tenantId,
  } = useClientInformationStore();
  const [allowAssistant, setAllowAssistant] = useState(
    checkIdExists(config.allowAssistant, tenantId)
  );
  useEffect(() => {
    setAllowAssistant(checkIdExists(config.allowAssistant, tenantId));
  }, [tenantId]);
  let workspaceData = { data: ws };
  let companyName = workspaceData?.data?.accountants[0]?.description;
  const itemClassification = workspaceData?.data?.itemType;
  const { t } = useTranslation("DOCS");

  const documentTitle =
    data && data?.title?.indexOf("Invoice issued to") !== -1
      ? t("document.invoice.issued") + data?.title?.slice(17)
      : data?.title?.indexOf("Invoice received from") !== -1
      ? t("document.invoice.received") + data?.title?.slice(21)
      : data?.title;

  const [commentCount, setCommentCount] = useState(0);
  const goBack = () => {
    window.history.go(-1);
  };

  const previewerSize = expandedDetails
    ? expandedAssistant || expandedComment
      ? 4
      : 8
    : expandedAssistant || expandedComment
    ? 8
    : 12;

  return (
    <>
      <VaporPage
        headerLeft={[
          <IconButton onClick={goBack} size="large">
            <FontAwesomeIcon
              icon={faArrowLeft}
              color={"#0090d1"}
              size={"2xs"}
            />
          </IconButton>,
        ]}
        title={newName ? newName : documentTitle}
        subtitle={data ? data.subTitle : companyName}
        sx={{
          "&.MuiCard-root .MuiBox-root .MuiTypography-titleSmall": {
            color: "#005075",
            fontWeight: "normal",
          },
          "&.MuiCard-root .MuiBox-root .MuiTypography-pageDescription": {
            color: "#5a6872",
          },
        }}
      >
        {loading ? (
          <div style={{ marginTop: "15%", marginLeft: "3%" }}>
            <Loading />
          </div>
        ) : (
          <div>
            <DocumentDetailUpperBar
              id={id}
              expandedComment={expandedComment}
              setexpandedComment={setExpandedComment}
              data={data}
              setExpandedDetails={setExpandedDetails}
              expandedDetails={expandedDetails}
              commentCount={commentCount}
              setExpandedAssistant={setExpandedAssistant}
              expandedAssistant={expandedAssistant}
            />
            <Box sx={{ flexGrow: 1, height: "100%" }}>
              <Grid style={{ height: "100%" }} container spacing={1}>
                {expandedDetails && (
                  <Grid item xs={4}>
                    <DocumentDetails
                      setCheckVisibility={setCheckVisibility}
                      isAccountant={ws?.itemType !== "COMPANY" ? true : false}
                      newName={newName}
                      setNewName={setNewName}
                      commentCount={commentCount}
                      setReload={setReload}
                      fetchDetails={fetch}
                      loading={loading}
                      setexpandedComment={setExpandedComment}
                      workspaceId={workspaceId}
                      expandedComment={expandedComment}
                      data={data}
                    />
                  </Grid>
                )}

                <Grid
                  item
                  xs={previewerSize}
                  sx={{
                    margin: `${
                      !expandedDetails &&
                      !expandedComment &&
                      !expandedAssistant &&
                      "0px 0px 0px 15%"
                    } `,
                  }}
                >
                  <DocPreviewer
                    fileName={data?.fileName}
                    isInvoice={data?.einvoice}
                    id={data?.einvoice ? id.split("_")[0] : id}
                    workspaceId={workspaceId}
                  />
                </Grid>
                <Grid item xs={4}>
                  {expandedComment && (
                    <DocumentNotes
                      tenantItemId={currentCompany?.itemId}
                      setCommentCount={setCommentCount}
                      documentId={id}
                      workspaceId={workspaceId}
                      itemClassification={itemClassification}
                    />
                  )}
                  {/* Ai component */}
                  {/* <IframeWrapper
                    docID={id}
                    wsID={workspaceId}
                    allowAssistant
                    expandedAssistant
                    docName={documentTitle}
                    userLangauge="it"
                    assistant="general_assistant"
                  /> */}
                  {/* {expandedAssistant && allowAssistant && (
                    <AiAsistant
                      documentName={data?.fileName}
                      documentId={id}
                      withSideDrawer={false}
                      workspaceId={workspaceId}
                      userLanguage={ws.userLanguage}
                    />
                  )} */}
                </Grid>
              </Grid>
            </Box>
          </div>
        )}
      </VaporPage>
      <VaporToolbar
        contentLeft={[
          <DocumentDetailsFooter
            readOnly={data?.readOnly}
            isInvoice={data?.einvoice}
            itemClassification={itemClassification}
            setStatusOnDelete={setStatusOnDelete}
            id={id}
            onOpenModal={() => setOpenModalDelete(!openModalDelete)}
            workspaceId={workspaceId}
          />,
        ]}
        contentRight={
          openModalDelete && (
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                marginBottom: "100%",
              }}
            >
              <DeleteDocumentAlert
                documentTitle={documentTitle}
                setStatusOnDelete={setStatusOnDelete}
                id={id}
                workspaceId={workspaceId}
                onDelete={setResponse}
                setShowError={setShowError}
                onCancel={() => {
                  setOpenModalDelete(false);
                }}
              />
              {!!response && (
                <Stack style={{ display: "flex", marginTop: "5px" }}>
                  <Alert
                    sx={{ width: "100%" }}
                    variant="outlined"
                    size="large"
                    severity="success"
                    icon={<FontAwesomeIcon icon={faCheckCircle} />}
                  >
                    <AlertTitle>{t("document.deletedSuccessfully")}</AlertTitle>
                  </Alert>
                </Stack>
              )}
              {error && (
                <Stack style={{ display: "flex", marginTop: "5px" }}>
                  <Alert severity="success">This is a success Alert.</Alert>
                </Stack>
              )}
            </div>
          )
        }
      ></VaporToolbar>
    </>
  );
};
